import { useEffect, useState } from 'react';
import aboutLogo from '../../asset/aboutImage.png'


function About() {
  const [isMobile, setIsMobile] = useState(window.innerWidth > 750);

    useEffect(() => {
        const handleResize = () => {
        setIsMobile(window.innerWidth > 750);
        };

        window.addEventListener('resize', handleResize);

        // Cleanup listener on component unmount
        return () => {
        window.removeEventListener('resize', handleResize);
        };
    }, []);

  return (
    <>
    <div className='home'>
        <div className='d-flex flex-wrap justify-content-center align-items-center home about-top pb-5'>
          <div className="col-md-6 col-12 d-flex flex-column justify-content-center align-items-center">
              <div className='p py-5 d-flex flex-column w-75'>
                  <h1 style={{ fontSize:isMobile ? "60px" : "40px" }} className='sub-title'>About US</h1>
                  <p>ANAB Minerals is a prominent Egypt-based supplier of premium minerals, including Talc, Silica Sand, and Kaolin, serving industries across Egypt, the Middle East, and beyond. At ANAB, our focus on quality and innovation, backed by advanced processing facilities and a skilled team, allows us to meet the diverse needs of our clients in various sectors.
<br/>
<br/>
Operating from Egypt with a growing international footprint, ANAB Minerals is dedicated to delivering top-quality mineral products in a wide array of grades, from ultra-fine powders to larger granular forms, each tailored to specific industrial applications. Our products support a range of industries, including ceramics, paints, plastics, paper, and more, offering optimal solutions that drive efficiency and enhance end products.
<br/>
<br/>
Quality assurance is at the core of our operations. Each batch undergoes meticulous testing in our labs, ensuring it meets the highest standards before shipment. With a commitment to precision and on-time delivery, ANAB Minerals is a trusted partner for companies that prioritize consistency, quality, and reliability.</p>
              </div>
            
          </div>
           <div className="col-md-6 col-12 d-flex justify-content-center align-items-center"> <img src={aboutLogo} className='img1'  alt="" srcset="" /></div>
        </div>
    </div>
    </>
  );
}

export default About;
